import { FC } from 'react';
import { usePOICoverImage, usePOIDescription, usePOILinkPreviewTitle } from '@poi/shared/use-poi-tdk';
import { DynamicHead } from '@lemon8/web-app-shared/ssr';

export const POITwitter: FC = () => {
  const title = usePOILinkPreviewTitle();
  const description = usePOIDescription();
  const cover = usePOICoverImage();

  return (
    <DynamicHead>
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content="@Lemon8" />
      <meta name="twitter:text:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={cover?.url || ''} />
    </DynamicHead>
  );
};
